/**
 * Os preços da clínica no painel (#1085): o texto que o "Copiar" põe na
 * mensagem e como ele entra no que já estava escrito.
 */

import type { PrecoDaClinica } from '@cliqcrm/contracts';
import { dinheiroComCentavos } from '@/shared/lib/formato';

/** "TC ABDOME TOTAL — R$ 520,00": o nome como o sistema da clínica manda, e o preço com centavos. */
export function textoDoPreco(preco: Pick<PrecoDaClinica, 'nome' | 'preco'>): string {
  return `${preco.nome} — ${dinheiroComCentavos(preco.preco) ?? ''}`.trim();
}

/**
 * O texto copiado entra no fim do que já estava na caixa, numa linha nova; a
 * caixa vazia (ou só com espaços) recebe só ele. Nada é apagado.
 */
export function juntarNaMensagem(atual: string, novo: string): string {
  const antes = atual.replace(/\s+$/, '');
  return antes === '' ? novo : `${antes}\n${novo}`;
}

export type DirecaoDaTroca = 'direita' | 'esquerda' | 'acima';

/**
 * De onde a lista nova entra no deslize: da direita quando se avança (o
 * filtro seguinte na ordem, ou a página seguinte), da esquerda quando se
 * volta, e de cima quando só a busca mudou.
 */
export function direcaoDaTroca<F extends string>(
  ordem: readonly F[],
  antes: { readonly filtro: F; readonly pagina: number },
  depois: { readonly filtro: F; readonly pagina: number },
): DirecaoDaTroca {
  const passo =
    ordem.indexOf(depois.filtro) - ordem.indexOf(antes.filtro) || depois.pagina - antes.pagina;
  return passo > 0 ? 'direita' : passo < 0 ? 'esquerda' : 'acima';
}
